import { getNextVideo } from './requests';
import { useQuery } from '@tanstack/react-query';

export function useGetNextVideo() {
  return useQuery({
    queryKey: ['video-obs', 'double-coders', 'next-video'],
    queryFn: () => getNextVideo().then(res => res.data),
    refetchOnWindowFocus: false
  });
}
